import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import { shirdiData } from './tourPackageData'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'

const Shirdi = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Shirdi Shanisinganapur " />
            <CommonBreadcrumb items={["Shirdi Shanisinganapur "]} />
            <DynamicTourSection {...shirdiData} />
            <Footer />
        </>
    )
}

export default Shirdi   